import * as PropTypes from 'prop-types';
import { ptColor } from '../../consts/propTypes.const';
export var iconButtonPropTypes = {
  accessibilityExpanded: PropTypes.bool,
  accessibilityHaspopup: PropTypes.bool,
  accessibilityLabel: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.func,
  color: ptColor
};